import React, { FunctionComponent } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import CenteredPage from '../styled/CenteredPage/CenteredPage'

const LoadingScreen: FunctionComponent<any> = () => (
  <CenteredPage>
    <LoadingOutlined />
  </CenteredPage>
)

export default LoadingScreen
